import styled from 'styled-components'
import Colors from 'builder/styles/colors'
import Sizes from 'builder/styles/sizes'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import Spinner from '../Spinner'
import spinner from './assets/spinner.png'
import whiteSpinner from './assets/white-spinner.png'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${Sizes.M};
  ${Media.Phone`
    padding-top: ${Sizes.S};
  `};
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Sizes.M};
  ${Media.Phone`
    gap: ${Sizes.S};
  `};
`
export const Title = styled.div`
  ${Typography.Body};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};
  padding-bottom: ${Sizes['2XS']};
`

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: ${Sizes['2XS']};
`

export const SlashedPrice = styled.span`
  color: #92cdfc;
  text-decoration: line-through;
`

export const PriceLoader = styled(Spinner)<{ type?: 'white' | 'default' }>`
  width: 24px;
  height: 24px;
  background-image: url(${({ type }) => (type === 'white' ? whiteSpinner : spinner)});
`
export const DetailsContainer = styled.div`
  padding-top: ${Sizes.XS};
  display: flex;
  justify-content: center;
`

export const Details = styled.div`
  ${Typography.Caption};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
  text-align: center;

  & span {
    ${FontWeights.DemiBold};
  }
`
